import axios from "axios";
import { baseUrl } from "./baseUrl";
const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true, // Include cookies in requests
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    const isAuthRoute =
      originalRequest.url.includes("/auth/refresh") ||
      originalRequest.url.includes("/admin/login") ||
      originalRequest.url.includes("/student/login");

    if (isAuthRoute) return Promise.reject(error);

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await api.post("/auth/refresh");
        return api(originalRequest);
      } catch (err) {
        return Promise.reject(error);

      }
    }

    return Promise.reject(error);
  }
);

export default api;
